import { Component } from '@angular/core';

@Component({
  selector: 'fgb-feeds-page',
  templateUrl: './feeds-page.component.html',
  styleUrl: './feeds-page.component.scss',
})
export class FeedsPageComponent {}
